import React from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Divider } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
// import InboxIcon from '@material-ui/icons/Inbox';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';

class RuleRows extends React.PureComponent {
  state = {
    expanded: null,
  };

  handleChange = () => (_event, expanded) => {
    this.setState({
      expanded: !expanded,
    });
  };

  render() {
    const { expanded } = this.state;
    const { aiRules, keyData, cat, onOpenModal } = this.props;

    return (
      <ExpansionPanel expanded={expanded} onChange={this.handleChange()}>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>{cat}</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{ flexDirection: 'column' }}>
          <List>
            {aiRules[keyData][cat].map((topic, i) => (
              <React.Fragment key={i}>
                <ListItem button onClick={() => onOpenModal(cat, topic)}>
                  <ListItemText primary={topic.headline} />
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}

class RulesTable extends React.Component {
  state = {
    isModalOpen: false,
    modalData: undefined,
  };

  handleOpenModal = (cat, data) => {
    this.setState({ modalData: { cat, data }, isModalOpen: true });
  };

  handleClose = () => {
    this.setState({ isModalOpen: false, modalData: undefined });
  };

  render() {
    const { aiRules } = this.props;

    if (!this.props.aiRules) {
      return <div />;
    }

    const content = Object.keys(aiRules).map((key, k) => {
      const categories = Object.keys(aiRules[key]).map((cat, j) => {
        return (
          <RuleRows
            aiRules={aiRules}
            keyData={key}
            cat={cat}
            key={`${k}${j}`}
            onOpenModal={this.handleOpenModal}
          />
        );
      });
      return (
        <div key={k} style={{ margin: '20px 0' }}>
          <Typography variant="headline" style={{ marginBottom: '10px' }}>
            {key}
          </Typography>
          <Paper>{categories}</Paper>
        </div>
      );
    });
    return (
      <React.Fragment>
        {this.state.isModalOpen && (
          <Dialog
            open={this.state.isModalOpen}
            onClose={this.handleClose}
            scroll="paper"
            maxWidth="lg"
          >
            <DialogTitle>{`Intent: ${this.state.modalData.data.headline}`}</DialogTitle>
            <DialogContent>
              <Typography variant="body2">{`Category: ${this.state.modalData.cat}`}</Typography>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div
                  style={{
                    flex: '1',
                    marginRight: '20px',
                    padding: '10px',
                    border: '1px solid #2f2f2f',
                  }}
                >
                  <Typography variant="body2">Training Phrases</Typography>
                  <div style={{ padding: '10px' }}>
                    {this.state.modalData.data.trainingPhase.map((phase, i) => (
                      <div style={{ display: 'flex' }} key={i}>
                        <ChatBubbleOutline />
                        <div style={{ marginLeft: '10px' }}>{phase}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div style={{ flex: '1', padding: '10px', border: '1px solid #2f2f2f' }}>
                  <Typography variant="body2">Text Response</Typography>
                  <div style={{ padding: '10px' }}>
                    {this.state.modalData.data.result.split('<br>').map(p => (
                      <Typography variant="body1">{p}</Typography>
                    ))}
                  </div>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        )}
        <div>{content}</div>
      </React.Fragment>
    );
  }
}

export default RulesTable;



// WEBPACK FOOTER //
// ./src/main/content/project/ai/components/RulesTable.js